import { render } from "./EdicionVendedor.vue?vue&type=template&id=53664e7a&scoped=true"
import script from "./EdicionVendedor.vue?vue&type=script&lang=js"
export * from "./EdicionVendedor.vue?vue&type=script&lang=js"

import "./EdicionVendedor.vue?vue&type=style&index=0&id=53664e7a&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53664e7a"]])

export default __exports__